import {usePlantDifficultySummaries, getCurrentDifficulty} from '@domain/pom'
import {ContentBox} from '@hconnect/common/components/ContentBox'
import {DataContentWrapper} from '@hconnect/common/containers'
import {easyPOM} from '@hconnect/common/hproduce/config/easyPOM'
import {ChevronRight} from '@mui/icons-material'
import {Link} from '@mui/material'
import React, {FC} from 'react'

import {CompletionSection} from '../components'

const SCORE_PROGRESS_TITLE = `Plant operating model - ${easyPOM.name}`

type Props = {
  plantId: string
  easyPomHref?: string
  onClick?: () => void
}

export const PomScoreProgressContainer: FC<Props> = ({plantId, easyPomHref, onClick}) => {
  const {
    data: difficultySummaries,
    isLoading,
    isError,
    isRefetching,
    refetch
  } = usePlantDifficultySummaries(plantId)
  return (
    <DataContentWrapper
      showLoader={isLoading}
      isError={isError}
      isRefetching={isRefetching}
      data={difficultySummaries}
      retryFunction={() => refetch()}
      placeholderWrapperSx={{width: '100%'}}
    >
      <Link
        href={easyPomHref}
        data-test-id="score-progress-section-link-to-easypom"
        onClick={onClick}
        sx={(theme) => ({
          textDecoration: 'none',
          '&:hover': {
            '& .card-chevron, .card-name': {
              color: theme.palette.primary.main
            }
          }
        })}
      >
        <ContentBox
          mode="max100PercentOfParentHeight"
          title={SCORE_PROGRESS_TITLE}
          afterTitle={<ChevronRight />}
          bodyWithPadding
          data-test-id="score-progress-section"
        >
          {difficultySummaries && (
            <CompletionSection
              activeDifficulty={getCurrentDifficulty(difficultySummaries)}
              difficultySummaries={difficultySummaries}
              data-test-id="completion-card-progress"
            />
          )}
        </ContentBox>
      </Link>
    </DataContentWrapper>
  )
}
